import template from './modal.html';
import { CreateCourseModalController as controller } from './modal.controller';
import { UniqueIdGeneratorUtil } from '@go-modules/utilities/unique-id-generator/unique-id-generator.util';

export class CreateCourseModalService {
	private defaultOptions = {
		template,
		controller,
		windowClass: 'goreact-modal create-course-modal',
		backdrop: 'static',
		controllerAs: '$ctrl',
		bindToController: true,
		goreact: true // For new modal styles
	};

	/** @ngInject */
	constructor (private goModalBootstrap) {}

	public open (options) {
		Object.assign(options, this.defaultOptions);
		options.modalData = {
			...(options.modalData ?? {}),
			dialogTitleId: options.modalData?.dialogTitleId ?? `create-course-modal-title-${UniqueIdGeneratorUtil.getId()}`
		};
		return this.goModalBootstrap.open(options);
	}
}
